import React, { useContext, useMemo } from "react";
import MediaDetailsWithSidebar from "../../components/MediaDetailsWithSidebar/MediaDetailsWithSidebar";
import MUILoader from "../../components/MUILoader/MUILoader";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import { getEntity } from "../../common/CommonFunctions";
import { CONTENT_STATUS_CONFIG } from "../../config/App.config";
import { ScrollManagementProvider } from "../../contexts/ScrollManagement.context";

const ContentManagement = ({
  // Services
  service,                 // required for list mode: { getAll(...) }
  fetchItem,               // optional for detail-by-id: async (id) => item or {data: item}

  // List config
  pageSize = 10,
  fetchParams = {},        // extra params or overrides (e.g., sort, sortBy)

  // Session entity handling
  useEntityFromSession = true,
  entityKey,               // optional key for getEntity(key)
  detailItem,              // optional direct detail entity (overrides session)
  detailItemId,            // optional id for detail mode (requires fetchItem)

  // Display
  contentType,
  sidebarItemLayout = "horizontal",

  // Mappers
  getId,
  getTitle,
  getSubtitle,
  getThumbnail,
  getIframeUrl,
  getDescription,

  // Actions
  onCardClick,
  onPlayClick,
  onLearnClick,
  onQuizClick,
  isFavoritesMode = false,
}) => {
  const { authUserDetails } = useContext(AppGlobalContext);
  const isLoading = !authUserDetails?.uid;

  const language = authUserDetails?.preferredLanguage || "English";

  const sessionEntity = useMemo(
    () => (useEntityFromSession ? getEntity(entityKey) : null),
    [useEntityFromSession, entityKey]
  );

  const effectiveDetailItem = detailItem || sessionEntity;

  // Build merged fetch params when in list mode
  const mergedFetchParams = useMemo(() => {
    return {
      page: 1,
      limit: pageSize,
      isActive: true,
      status: CONTENT_STATUS_CONFIG.PUBLISHED,
      language,
      ...fetchParams,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, pageSize, JSON.stringify(fetchParams)]);

  const modeProps = effectiveDetailItem
    ? {
        mode: "detail",
        detailItem: effectiveDetailItem,
        detailItemId,
        fetchItem,
      }
    : {
        mode: "list",
        fetchItems: service,
        fetchParams: mergedFetchParams,
        pageSize,
      };

  if (isLoading) return <MUILoader />;

  return (
    <ScrollManagementProvider>
      <MediaDetailsWithSidebar
        {...modeProps}
        contentType={contentType}
        sidebarItemLayout={sidebarItemLayout}
        getId={getId}
        getTitle={getTitle}
        getSubtitle={getSubtitle}
        getThumbnail={getThumbnail}
        getIframeUrl={getIframeUrl}
        getDescription={getDescription}
        onCardClick={onCardClick}
        onPlayClick={onPlayClick}
        onLearnClick={onLearnClick}
        onQuizClick={onQuizClick}
        isFavoritesMode={isFavoritesMode}
      />
    </ScrollManagementProvider>
  );
};

export default ContentManagement;